import { ValidationLengthUnder255 } from '..';

export const MasterMiddleCategoryValidation = (largeCategoryName: number, name: string) => (
  // 必須
  !largeCategoryName
  || !name

  // バリデーション
  || ValidationLengthUnder255.filter((v) => !v.run(String(name || ''))).length
);
